module.exports = __webpack_public_path__ + "img/kanelsnurrer.d8ac3acc.jpg";